import script from "./whCOnceImg1.vue?vue&type=script&setup=true&lang=js"
export * from "./whCOnceImg1.vue?vue&type=script&setup=true&lang=js"

import "./whCOnceImg1.vue?vue&type=style&index=0&id=b409d386&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b409d386"]])

export default __exports__